var _polygon, _polygon2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCzechFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "72 0 216 216",
    enableBackground: "new 72 0 216 216",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "123.4,71.4 178.7,108.2 123.4,145 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.6,
    enableBackground: "new    ",
    points: "234,145 234,108.2 178.7,108.2 123.4,145 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    fill: "#231F20",
    enableBackground: "new    ",
    d: "M234,63.6H123.4h-7.8v7.8v42v7.8V145v7.8h7.8H234h7.8V145V71.4 v-7.8C241.8,63.6,234,63.6,234,63.6z M234,145H123.4v-23.7v-7.8v-42H234V145z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCzechFlag);
export default __webpack_public_path__ + "static/media/czech-flag.d57ad784e9d646e3673645897ace6f0d.svg";
export { ForwardRef as ReactComponent };